/**
 * CORE-1517 — the handshake between the error screen's «Попробовать снова»
 * and the lazily loaded screens.
 *
 * `React.lazy` remembers a rejection for good and re-throws it on every later
 * render, so a retry has to render a NEW lazy component to start a new
 * import(). Replacing it the moment the import fails does not work: React
 * re-renders right after the rejection to surface the error, finds the fresh
 * component, suspends on it again, and the page sits on the loader forever.
 * The swap has to wait for an actual retry — which is what this counter marks.
 */
let generation = 0;

/** Called by the error boundary on retry: failed screens may import again. */
export function bumpLazyRetry(): void {
    generation++;
}

export function lazyRetryGeneration(): number {
    return generation;
}
